export interface ClientFormData {
  email: string
  first_name: string
  last_name: string
  country: string
  place: string
  street: string
  house_number: string
  zip_code: string
  phone_number: string
  email_address: string
  company_name: string
  client_type: 'company' | 'personal'
  tax_number: string
  vat_number: string
  id_number: string
  document_number: string
}

export const validateClientForm = (values: ClientFormData): Partial<ClientFormData> => {
  const errors: Partial<ClientFormData> = {}

  const requiredFields = [
    'first_name',
    'last_name',
    'country',
    'place',
    'street',
    'house_number',
    'zip_code',
    'phone_number'
  ] as const

  requiredFields.forEach((field) => {
    const value = values[field]
    if (typeof value !== 'string' || value.trim() === '') {
      errors[field] = 'required'
    }
  })

  if (values.client_type === 'company') {
    if (typeof values.company_name !== 'string' || values.company_name.trim() === '') {
      errors.company_name = 'required'
    }
  }

  return errors
}
